
import { NgModule } from '@angular/core';
import { SiriusAppModule } from 'sirius-framework';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/modules/shared.module';
import { InnerMenuSalesRoutingModule } from './inner-menu-sales.routing.module';

import { InnerMenuSalesComponent } from './inner-menu-sales.component';
import { SalesIndividualComponent } from './components/sales-individual/sales-individual.component';
import { SalesCorporateComponent } from './components/sales-corporate/sales-corporate.component';

import { IndividualSalesService } from './inner-menu-sales.service';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        InnerMenuSalesRoutingModule
    ],
    declarations: [
        InnerMenuSalesComponent,
        SalesIndividualComponent,
        SalesCorporateComponent
    ],
    providers: [IndividualSalesService]
})
export class InnerMenuSalesModule { }
